import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      data-testid="language-toggle-btn"
      className="fixed top-12 right-4 z-50 flex items-center gap-2 px-4 py-2 rounded-full
                 bg-white border-2 border-brand-gold/40 shadow-gold-glow
                 hover:border-brand-gold hover:bg-brand-cream
                 transition-all duration-300 group"
    >
      <Globe className="w-4 h-4 text-brand-maroon group-hover:rotate-12 transition-transform" />
      <span className="text-brand-maroon text-sm font-bold font-outfit">
        {language === 'en' ? 'हिंदी' : 'English'}
      </span>
    </button>
  );
};

export default LanguageToggle;
